module.exports = __webpack_public_path__ + "static/media/MTL_SL_KETONE3.3631da48.png";